import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Award, ArrowRight, Heart } from 'lucide-react';
import { useSavedListings } from '@/hooks/useSavedListings';
import FranchiseCard from '@/components/card/FranchiseCard';
import { Spinner, Pagination } from '@/components/common';

export default function SavedFranchisesPage() {
  const [filters, setFilters] = useState({
    entityType: 'Franchise',
    page: 1,
    limit: 10,
    orderBy: 'createdAt',
    orderDirection: 'DESC'
  });

  const { data: listingsData, isLoading } = useSavedListings(filters);
  const franchises = listingsData?.data?.filter((l) => l.entityType === 'Franchise' && l.franchise).map((l) => l.franchise!) ?? [];

  const total = listingsData?.total ?? 0;
  const totalPages = Math.ceil(total / filters.limit);

  return (
    <div className="max-w-6xl mx-auto pb-12 animate-fade-in">
      {/* Header */}
      <div className="mb-6">
        <div className="section-label">Nhượng quyền</div>
        <div className="flex items-end justify-between flex-wrap gap-2">
          <div>
            <h1 className="section-title mb-1">Thương hiệu đã lưu</h1>
            <p className="text-sm" style={{ color: 'var(--text-3)' }}>
              Danh sách các thương hiệu nhượng quyền bạn đã lưu lại
            </p>
          </div>
          <Link
            to="/nhuong-quyen"
            className="flex items-center gap-1.5 text-sm font-semibold px-4 py-2 rounded-xl border hover:border-orange-400 hover:text-orange-500 transition-colors"
            style={{ borderColor: 'var(--border-c)', color: 'var(--text-2)' }}
          >
            <Award size={14} /> Khám phá thêm thương hiệu
          </Link>
        </div>
      </div>

      {/* List */}
      {isLoading ? (
        <Spinner />
      ) : franchises.length === 0 ? (
        <div className="text-center py-24 rounded-2xl border" style={{ borderColor: 'var(--border-c)', background: 'var(--surface-0)' }}>
          <p className="text-5xl mb-4 text-orange-400 flex justify-center"><Heart size={48} /></p>
          <p className="font-bold text-lg mb-2" style={{ color: 'var(--text-1)' }}>
            Bạn chưa lưu thương hiệu nào
          </p>
          <p className="text-sm mb-6" style={{ color: 'var(--text-3)' }}>
            Lưu lại các thương hiệu tiềm năng để xem lại sau
          </p>
          <Link to="/nhuong-quyen" className="btn-brand inline-flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold">
            Khám phá thương hiệu <ArrowRight size={15} />
          </Link>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {franchises.map((item, i) => (
              <div key={item.id} className="animate-fade-up h-full" style={{ animationDelay: `${i * 50}ms` }}>
                <FranchiseCard item={item} />
              </div>
            ))}
          </div>
          {totalPages > 1 && (
            <Pagination
              page={filters.page}
              totalPages={totalPages}
              onChange={(p) => setFilters((f) => ({ ...f, page: p }))}
            />
          )}
        </>
      )}
    </div>
  );
}
